/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getExperimentOverrides';
import type { GetExperimentQueryParams } from '../../operation-overrides/getExperimentOverrides';

export type GetExperimentPathParams = NonNullable<operations['getExperiment']['parameters']['path']>;
export type { GetExperimentQueryParams };

export interface Input extends GetExperimentPathParams {
  apiVersion?: string;
  query?: GetExperimentQueryParams;
}

export async function getExperiment(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/environments/{environmentKey}/experiments/{experimentKey}', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
